<template>
  <div>
    <section class="hero">
      <div class="hero-body">
        <p class="title">RCI {{ i18n.setting[iso] }}</p>
        <!-- <b-tag type="is-success">{{ i18n.downloadInventory[iso] }}</b-tag> -->
        <div class="columns">
          <div class="column is-3">
            <b-button
              icon-left="download"
              icon-pack="fas"
              type="is-success"
              size="is-small"
              @click="downloadWeeks()"
              expanded
              >{{ i18n.downloadInventory[iso] }}</b-button
            >
          </div>
        </div>

        <!-- <p class="subtitle">Hero subtitle</p> -->
      </div>
    </section>
    <b-tabs v-model="tabFilters" position="is-centered">
      <b-tab-item>
        <template #header>
          <b-icon icon="filter" pack="fas" type="is-info"></b-icon>
          <b>{{ i18n.advancedSearch[iso] }}</b>
        </template>
        <div class="columns is-multiline">
          <div class="column is-3">
            <b-field label-position="on-border" label="ID">
              <b-input
                v-model="filters.Id"
                type="text"
                icon-right="times"
                icon-right-clickable
                expanded
              >
              </b-input>
            </b-field>
          </div>
          <div class="column is-3">
            <b-field label-position="on-border" :label="i18n.name[iso]">
              <b-input
                v-model="filters.Nombre"
                type="text"
                icon-right="times"
                icon-right-clickable
                expanded
              >
              </b-input>
            </b-field>
          </div>
          <div class="column is-3">
            <b-field label-position="on-border" :label="i18n.status[iso]">
              <b-select v-model="filters.Estado" expanded>
                <option :value="null">{{ i18n.all[iso] }}</option>
                <option :value="true">{{ i18n.active[iso] }}</option>
                <option :value="false">{{ i18n.blocked[iso] }}</option>
              </b-select>
            </b-field>
          </div>
          <!-- <div class="column is-8"></div> -->
          <div class="column is-1">
            <b-button
              icon-left="eraser"
              icon-pack="fas"
              type="is-danger is-light"
              @click="clearFilters"
              expanded
            ></b-button>
          </div>
          <div class="column is-2">
            <b-button
              icon-left="search"
              icon-pack="fas"
              type="is-info"
              @click="listResorts()"
              expanded
              >{{ i18n.search[iso] }}</b-button
            >
          </div>
        </div>
      </b-tab-item>
    </b-tabs>
    <b-table
      :data="resorts"
      :paginated="isPaginated"
      backend-pagination
      :total="total"
      :per-page="perPage"
      @page-change="onPageChange"
      :current-page.sync="currentPage"
      :pagination-simple="isPaginationSimple"
      :pagination-position="paginationPosition"
      :default-sort-direction="defaultSortDirection"
      :pagination-rounded="isPaginationRounded"
      :sort-icon="sortIcon"
      :sort-icon-size="sortIconSize"
      aria-next-label="Next page"
      aria-previous-label="Previous page"
      aria-page-label="Page"
      aria-current-label="Current page"
      :bordered="isBordered"
      :striped="true"
      :narrowed="isNarrowed"
      :hoverable="true"
      :loading="loadingTableList"
      :focusable="isFocusable"
      :mobile-cards="hasMobileCards"
      :detailed="false"
    >
      <b-table-column field="ID" label="ID" centered v-slot="props">
        {{ props.row.Id ? props.row.Id.split("-")[0] : "" }}
      </b-table-column>

      <b-table-column
        field="Name"
        :label="i18n.name[iso]"

        centered
        v-slot="props"
      >
        {{ props.row.Name || "" }}
      </b-table-column>

      <b-table-column
        field="Location"
        :label="i18n.location[iso]"

        centered
        v-slot="props"
      >
        {{ props.row.Country || "" }}, {{ props.row.State || "" }},
        {{ props.row.City || "" }}
      </b-table-column>

      <b-table-column
        field="Bloqueado"
        :label="i18n.status[iso]"

        centered
        v-slot="props"
      >
        <b-tag v-if="!props.row.Bloqueado" type="is-success">{{
          i18n.active[iso]
        }}</b-tag>
        <b-tag v-else type="is-danger">{{ i18n.blocked[iso] }}</b-tag>
      </b-table-column>

      <b-table-column label="Actions" v-slot="props" centered>
        <b-tooltip type="is-success is-light" v-if="props.row.Bloqueado">
          <b-button
            icon-left="unlock"
            icon-pack="fas"
            size="is-small"
            type="is-success is-light"
            style="margin-right: 10px"
            @click="unlockResort(props.row._id)"
          ></b-button>
          <template v-slot:content>
            <b>{{ i18n.unlock[iso] }}</b></template
          >
        </b-tooltip>
        <b-tooltip type="is-danger is-light" v-else>
          <b-button
            icon-left="lock"
            icon-pack="fas"
            size="is-small"
            type="is-danger is-light"
            style="margin-right: 10px"
            @click="lockResort(props.row._id)"
          ></b-button>
          <template v-slot:content>
            <b>{{ i18n.lock[iso] }}</b></template
          >
        </b-tooltip>
      </b-table-column>

      <template #footer>
        <div class="columns">
          <div class="column is-11"></div>

          <div class="column is-1">
            <b-field :label="i18n.quantity[iso]">
              <b-select v-model="perPage" @input="savePerPage" expanded>
                <option :value="5">5</option>
                <option :value="10">10</option>
                <option :value="20">20</option>
                <option :value="50">50</option>
              </b-select>
            </b-field>
          </div>
        </div>
        <!-- <div class="has-text-right">Footer</div> -->
      </template>
    </b-table>
  </div>
</template>

<script>
import axios from "axios";
const API_URL = process.env.VUE_APP_API_URL;
import moment from "moment";
import i18n from "../../utils/i18n";
// import ModalCreateUserSystem from "./ModalCreateUserSystem.vue";
// import ModalCreateRoleSystem from "./ModalCreateRoleSystem.vue";

const listCatalogues = ["CatIdiomas"];

export default {
  data() {
    return {
      isPaginated: true,
      isPaginationSimple: true,
      isPaginationRounded: false,
      paginationPosition: "bottom",
      defaultSortDirection: "asc",
      sortIcon: "arrow-up",
      sortIconSize: "is-small",
      currentPage: 1,
      perPage: 10,
      hasInput: false,
      paginationOrder: "",
      inputPosition: "",
      inputDebounce: "",
      isBordered: false,
      isStriped: true,
      isNarrowed: true,
      isHoverable: true,
      isFocusable: false,
      hasMobileCards: true,

      tabFilters: 0,
      filters: {
        Nombre: null,
        Id: null,
        Estado: null,
      },
      minDate: new Date(2000, 0, 1),
      maxDate: new Date(),
      clubesName: [],
      loadingExport: false,

      //Loading
      loadingTableList: false,
      loadingButton: false,

      //Data
      resorts: [],
      total: 0,
      roles: [],
      listCatalogues,
      catalogues: {},

      //Modals
      ModalCreateUser: false,
      ModalCreateRole: false,

      //i18n
      i18n,
      iso: null,

      //Permissions
      permissions: "",
    };
  },
  async created() {
    this.iso = localStorage.getItem("iso");
    this.$bus.on("change-iso", () => {
      this.iso = localStorage.getItem("iso");
    });

    //Permissions
    this.permissions = localStorage.getItem("role");

    //PerPage
    // const perPageLocalStorage = localStorage.getItem("perPageReserves");
    // if (!perPageLocalStorage) this.savePerPage();
    // else this.perPage = perPageLocalStorage;

    //
    await this.listResorts();
  },
  methods: {
    async listResorts() {
      try {
        this.loadingTableList = true;
        let query = `?limit=${this.perPage}&page=${this.currentPage}`;
        const { data } = await axios.post(`${API_URL}/week/resorts${query}`, {
          ...this.filters,
        });
        this.resorts = data?.resorts || [];
        this.total = (data?.resorts && data?.resorts.length) || 0;
        this.loadingTableList = false;
      } catch (err) {
        this.loadingTableList = false;
        console.log(err);
        this.$buefy.toast.open({
          message: "Error al consultar usuarios",
          type: "is-danger",
        });
      }
    },
    savePerPage() {
      // localStorage.setItem("perPageReserves", this.perPage);
      // this.listResorts();
    },
    onPageChange(page) {
      this.currentPage = page;
      // console.log("checkAdvancedSearch()", checkAdvancedSearch());
      // if (this.searchMembers && this.searchMembers !== "") {
      //   this.listAllMembers({
      //     rgx: this.searchMembers,
      //   });
      // } else if (this.checkAdvancedSearch(false)) {
      //   this.listAllMembers(this.advancedFilters);
      // } else {
      //   this.listResorts();
      // }
    },
    parseDate(value) {
      moment.locale(this.iso);
      return value ? moment(value).format("MMMM D, YYYY") : "";
    },

    async clearFilters() {
      this.filters = {
        Nombre: null,
        Id: null,
        Estado: null,
      };
      await this.listResorts();
    },
    async unlockResort(resortId) {
      this.$buefy.dialog.confirm({
        message: this.i18n.unlock__msg1[this.iso],
        type: "is-success",
        hasIcon: true,
        icon: "unlock",
        iconPack: "fas",
        confirmText: this.i18n.yes[this.iso],
        cancelText: this.i18n.no[this.iso],
        onConfirm: () => {
          this.$buefy.dialog.confirm({
            message: this.i18n.unlock__msg4[this.iso],
            type: "is-warning",
            hasIcon: true,
            iconPack: "fas",
            confirmText: this.i18n.iUnderstand[this.iso],
            cancelText: this.i18n.goBack[this.iso],
            onConfirm: async () => {
              try {
                this.loadingTableList = true;
                await axios.put(`${API_URL}/week/resort-unlock/${resortId}`);
                await this.listResorts();
                this.loadingTableList = false;
                this.$buefy.toast.open({
                  message: this.i18n.unlock__msg2[this.iso],
                  type: "is-success",
                });
              } catch (err) {
                this.loadingTableList = false;
                console.log(err);
                this.$buefy.toast.open({
                  message: this.i18n.unlock__msg3[this.iso],
                  type: "is-danger",
                });
              }
            },
          });
        },
      });
    },
    async lockResort(resortId) {
      this.$buefy.dialog.confirm({
        message: this.i18n.lock__msg1[this.iso],
        type: "is-danger",
        hasIcon: true,
        icon: "lock",
        iconPack: "fas",
        confirmText: this.i18n.yes[this.iso],
        cancelText: this.i18n.no[this.iso],
        onConfirm: () => {
          this.$buefy.dialog.confirm({
            message: this.i18n.lock__msg4[this.iso],
            type: "is-warning",
            hasIcon: true,
            iconPack: "fas",
            confirmText: this.i18n.iUnderstand[this.iso],
            cancelText: this.i18n.goBack[this.iso],
            onConfirm: async () => {
              try {
                this.loadingTableList = true;
                await axios.put(`${API_URL}/week/resort-lock/${resortId}`);
                await this.listResorts();
                this.loadingTableList = false;
                this.$buefy.toast.open({
                  message: this.i18n.lock__msg2[this.iso],
                  type: "is-success",
                });
              } catch (err) {
                this.loadingTableList = false;
                console.log(err);
                this.$buefy.toast.open({
                  message: this.i18n.lock__msg3[this.iso],
                  type: "is-danger",
                });
              }
            },
          });
        },
      });
    },
    changeTab() {
      this.tabFilters = 0;
      this.$forceUpdate();
      // if (this.tabFilters === 1) {
      //   this.downloadWeeks();
      // }
    },
    async downloadWeeks() {
      this.$buefy.dialog.confirm({
        message: this.i18n.downloadInventory__msg1[this.iso],
        type: "is-success",
        hasIcon: true,
        icon: "download",
        iconPack: "fas",
        confirmText: this.i18n.yes[this.iso],
        cancelText: this.i18n.no[this.iso],
        onConfirm: async () => {
          try {
            await axios.post(`${API_URL}/week/inventory-download`, {
              username: localStorage.getItem("user"),
            });
            this.$buefy.toast.open({
              message: this.i18n.downloadInventory__msg2[this.iso],
              type: "is-success",
            });
          } catch (err) {
            console.log(err);
            this.$buefy.toast.open({
              message: this.i18n.downloadInventory__msg3[this.iso],
              type: "is-danger",
            });
          }
        },
      });
    },
  },
};
</script>
